"use strict";
// Do not edit directly
// Generated on Wed, 23 Nov 2022 21:39:09 GMT
exports.__esModule = true;
exports["default"] = {
    colors: {
        app: {
            background: 'rgb(252, 252, 252)',
            backgroundAlt: 'rgb(247, 247, 247)'
        },
        border: {
            "default": 'rgb(68, 68, 69)',
            grey: 'rgb(223, 224, 225)',
            greyStrong: 'rgb(188, 188, 189)',
            primary: 'rgb(34, 112, 238)',
            primarySubdued: 'rgb(169, 209, 255)',
            secondary: 'rgb(105, 84, 192)',
            secondarySubdued: 'rgb(193, 182, 242)',
            critical: 'rgb(225, 50, 18)',
            criticalSubdued: 'rgb(255, 178, 160)',
            warningSubdued: 'rgb(255, 240, 177)',
            successSubdued: 'rgb(144, 239, 192)'
        },
        focus: {
            ringPrimary: 'rgb(169, 209, 255)',
            ringCritical: 'rgb(255, 178, 160)'
        },
        active: {
            "default": 'rgba(20, 20, 20, 0.2)',
            strong: 'rgba(20, 20, 20, 0.4)',
            primary: 'rgba(0, 76, 195, 0.2)',
            critical: 'rgba(225, 50, 18, 0.3)',
            onGrey: 'rgba(20, 20, 20, 0.16)',
            onPrimary: 'rgba(20, 20, 20, 0.08)',
            onCritical: 'rgba(20, 20, 20, 0.16)'
        },
        hover: {
            "default": 'rgba(20, 20, 20, 0.08)',
            subdued: 'rgba(68, 68, 69, 0.04)',
            primary: 'rgba(34, 112, 238, 0.08)',
            critical: 'rgba(225, 50, 18, 0.1)',
            onGrey: 'rgba(20, 20, 20, 0.08)',
            onPrimary: 'rgba(255, 255, 255, 0.16)',
            onCritical: 'rgba(255, 255, 255, 0.16)'
        },
        status: {
            critical: 'rgb(249, 77, 50)',
            criticalStrong: 'rgb(191, 42, 0)',
            info: 'rgb(34, 112, 238)',
            infoStrong: 'rgb(0, 76, 195)',
            success: 'rgb(24, 167, 97)',
            successStrong: 'rgb(16, 134, 75)',
            warning: 'rgb(255, 190, 0)',
            warningStrong: 'rgb(222, 149, 0)',
            "default": 'rgb(140, 156, 165)'
        },
        surface: {
            "default": 'rgb(255, 255, 255)',
            inverted: 'rgb(45, 46, 49)',
            invertedStrong: 'rgb(20, 20, 20)',
            grey: 'rgb(238, 238, 238)',
            greyStrong: 'rgb(223, 224, 225)',
            greyStronger: 'rgb(188, 188, 189)',
            greySubdued: 'rgb(247, 247, 247)',
            primary: 'rgb(34, 112, 238)',
            primarySubdued: 'rgb(236, 244, 253)',
            secondary: 'rgb(105, 84, 192)',
            secondarySubdued: 'rgb(241, 237, 255)',
            critical: 'rgb(225, 50, 18)',
            criticalSubdued: 'rgb(255, 236, 233)',
            successSubdued: 'rgb(225, 253, 239)',
            warningSubdued: 'rgb(255, 249, 226)',
            disabled: 'rgb(96, 97, 98)'
        },
        text: {
            "default": 'rgb(20, 20, 20)',
            inverted: 'rgb(255, 255, 255)',
            subdued: 'rgb(96, 97, 98)',
            primary: 'rgb(19, 96, 217)',
            primarySubdued: 'rgb(169, 209, 255)',
            secondary: 'rgb(105, 84, 192)',
            secondarySubdued: 'rgb(193, 182, 242)',
            critical: 'rgb(191, 42, 0)',
            onGrey: 'rgb(68, 68, 69)',
            onGreySubdued: 'rgb(148, 149, 150)',
            onPrimary: 'rgb(255, 255, 255)',
            onSecondary: 'rgb(255, 255, 255)',
            onWarning: 'rgb(20, 20, 20)',
            onCritical: 'rgb(255, 255, 255)'
        }
    }
};
